import { useCallback, useEffect } from 'react';

import { useNavigate, useSearchParams } from 'react-router';

import LoadingPage from '@/components/common/LoadingPage';
import { useOffice } from '@/components/providers/OfficeProvider';
import paths from '@/lib/paths';

export default function LoginCallback() {
  const { isOfficeEnvironment } = useOffice();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const buildMessage = useCallback(() => {
    const code = searchParams.get('code');
    const scope = searchParams.get('scope');
    const state = searchParams.get('state');

    const items = { ...localStorage };

    const localStorageItem = Object.entries(items).find(([key]) =>
      key.startsWith('oidc'),
    );

    return JSON.stringify({ code, scope, state, localStorageItem });
  }, [searchParams]);

  useEffect(() => {
    if (!isOfficeEnvironment) {
      navigate({
        pathname: paths.root,
        search: window.location.search,
      });

      return;
    }

    const message = buildMessage();

    // Send message to parent - the parent will close the dialog
    Office.context.ui.messageParent(message);
  }, [buildMessage, isOfficeEnvironment, navigate]);

  return <LoadingPage />;
}
